<template>
  <div>
    <BaseButton primary @click="create"> Add funnel stage </BaseButton>
  </div>
</template>

<script>
import { funnelStagesClient } from '@/api/clients';

export default {
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    async store(data) {
      try {
        await funnelStagesClient.store(this.funnel.id, data);

        this.$emit('created');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    create() {
      this.$modal.show({
        component: () => import('Components/FunnelStage/FunnelStageModal.vue'),
        props: {
          action: this.store,
          accountId: this.funnel.account_id,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
